import React from 'react'

import BaseModal from '../../../../molecules/ChatModals/BaseModal2'
import Button from '../../../../atoms/Button2'

import { ITEMS } from '../FilterMenu'
import { useBreakpoint } from '../../../../../providers/BreakpointProvider'
import useStyles from './styles'

type FilterModalProps = {
  selected: string[]
  onClose: (e: any) => void
  onSave: (e: any, name: string) => void
}

const FilterModal: React.FC<FilterModalProps> = ({
  selected,
  onClose,
  onSave
}) => {
  const { isMedium } = useBreakpoint()

  const [name, setName] = React.useState('')

  const classes = useStyles()

  return (
    // @ts-ignore
    <BaseModal
      open
      title='Save View'
      onClose={onClose}
      PaperProps2={{
        style: {
          padding: '20px 16px 24px 16px',
          border: '1px solid #C6C6C6',
          borderRadius: '4px',
          width: isMedium ? 'calc(100% - 4rem)' : '100%',
          maxWidth: isMedium ? 'unset' : '360px',
          height: isMedium && `auto`,
          maxHeight: isMedium && 'unset',
          minHeight: isMedium && 'auto'
        }
      }}
      classes={{ title: classes.modalTitle, close: classes.modalClose }}
    >
      <div className={classes.title}>Selected View</div>

      <div className={classes.content}>
        {ITEMS.map(item => {
          if (!selected.includes(item.id)) {
            return null
          }

          return (
            <div key={item.id} className={classes.item}>
              {item.content}
            </div>
          )
        })}
      </div>

      <div className={classes.name}>Name</div>

      <input
        value={name}
        onChange={e => setName(e.target.value)}
        placeholder='Enter view name'
        className={classes.input}
      />

      <Button
        onClick={e => onSave(e, name)}
        disabled={name.trim().length === 0}
        className={classes.button}
      >
        Save View
      </Button>
    </BaseModal>
  )
}

export default FilterModal
